import TemporaryUserTrace from './trace'
export default TemporaryUserTrace
